export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";